import Vue from 'vue';
import VueRouter from 'vue-router';
//import Home from '../views/Home.vue';
import Home from '../views/newHomePage/index.vue';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/list/:id/:name',
    name: 'NewsList',
    component: () => import('../views/NewsList.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/detail/6-10',
    name: 'MemberFeeStandard',
    component: () => import('../views/MemberFeeStandard.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/detail/:id',
    name: 'NewsDetail',
    component: () => import('../views/NewsDetail.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/jiagou',
    name: 'jiagou',
    component: () => import('../views/jiagou.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/publicity',
    name: 'PublicityList',
    component: () => import('../views/publicityList.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/publicitydetail',
    name: 'PublicityDetail',
    component: () => import('../views/publicityDetail.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/CertificateQuery.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/onlinelist',
    name: 'OnlineList',
    component: () => import('../views/OnlineList.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('../views/platform.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/expertRegister/register.vue'),
  },
  {
    path: '/member',
    name: 'MemberCenter',
    component: () => import('../views/MemberCenter.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/member/news',
    name: 'MemberNews',
    component: () => import('../views/MemberNews.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/member/intro',
    name: 'MemberIntro',
    component: () => import('../views/MemberIntro.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/member/certificate',
    name: 'MemberCertificate',
    component: () => import('../views/MemberCertificate.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/detail/6-10',
    name: 'MemberFeeStandard',
    component: () => import('../views/MemberFeeStandard.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/searchList',
    name: 'searchList',
    component: () => import('../views/searchList.vue'),
    meta: {
      keepAlive: true
    }
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
